import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { delay, finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { SpAuthService } from '../utility-services/auth.service';
import { phoneUpdateOtpUrl, validateOtpUrl } from '../constants/urls';
import { SpAuthMfaService } from '../utility-services';

@Injectable({ providedIn: 'root' })
export class SpHttpPhoneUpdateInterceptor implements HttpInterceptor {
  constructor(private authMfa: SpAuthMfaService) {}

  intercept(req: HttpRequest<Request>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes(phoneUpdateOtpUrl) || req.url.includes(validateOtpUrl)) {
      // Retrieve and add MFA Access token
      return next.handle(this.addAuthToken(req));
    } else {
      //Pass it along as is
      return next.handle(req);
    }
  }

  addAuthToken(request: HttpRequest<Request>) {
    const mfaAccessToken = this.authMfa.mfaAccessToken;

    const req = request.clone({
      setHeaders: {
        MfaAccessToken: `${mfaAccessToken}`,
      },
    });
    return req;
  }
}
